// extracted by mini-css-extract-plugin
export default {"imgbox":"Map_imgbox__AVUjV","centerFit":"Map_centerFit__J+zwO"};